var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedGroup2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21C13.4101 21 11 23.2503 11 26.5058V27C11 27.5523 11.4477 28 12 28H22C22.5523 28 23 27.5523 23 27V26.5058C23 23.2503 20.5899 21 17 21Z",
    stroke: "#4B5563",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15.6C13.5 13.6118 15.067 12 17 12C18.933 12 20.5 13.6118 20.5 15.6V17.4C20.5 19.3882 18.933 21 17 21C15.067 21 13.5 19.3882 13.5 17.4V15.6Z",
    stroke: "#4B5563",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3725 29H27.9999C29.1045 29 29.9999 28.1046 29.9999 27V26.5058C29.9999 23.6695 28.1983 21.5717 25.7324 20.6003C26.5194 19.7682 26.9999 18.6358 26.9999 17.4V15.6C26.9999 13.0862 25.0115 11 22.4999 11C22.0327 11 21.5836 11.0722 21.1621 11.2059C21.6851 11.7198 22.115 12.3284 22.4271 13.0011C22.4513 13.0004 22.4756 13 22.4999 13C23.8542 13 24.9999 14.1373 24.9999 15.6V17.4C24.9999 18.6784 24.1247 19.7083 22.9999 19.9475V20.0411L24.3366 22.2324C26.5563 22.8249 27.9999 24.4887 27.9999 26.5058V27H25.9999C25.9999 27.7436 25.7679 28.4331 25.3725 29Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedGroup2);
export default __webpack_public_path__ + "static/media/selectedGroup (2).4b9cadc9cb25745649ef86ba81efccd5.svg";
export { ForwardRef as ReactComponent };